/* ##############################################################################
#
#   Ant Design v5
#   Customize theme and tokens: 
#   https://ant.design/docs/react/customize-theme#seedtoken
#
############################################################################### */

import { type ThemeConfig } from 'antd';

const palette = {
  colorPrimary: '#1677ff',
  colorError: '#ff4d4f',
  colorInfo: '#1677ff',
  colorSuccess: '#52c41a',
  colorWarning: '#faad14',
  colorWhite: '#ffffff',
  colorText: 'rgba(0,0,0, 0.88)',
  colorIcon: 'rgba(0,0,0, 0.45)',
  colorDisabled: 'rgba(0,0,0, 0.25)',
};

export const antdTheme: ThemeConfig = {
  token: {
    /* sync with css vars manyally */
    colorPrimary: palette.colorPrimary,
    colorError: palette.colorError,
    colorInfo: palette.colorInfo,
    colorSuccess: palette.colorSuccess,
    colorWarning: palette.colorWarning,
    colorWhite: palette.colorWhite,
    colorText: palette.colorText,
    fontFamily: 'Arial',
    screenSMMax: 743,
    screenMD: 744,
    screenMDMin: 744,
    screenMDMax: 1023,
    screenLG: 1024,
    screenLGMin: 1024,
    screenLGMax: 1279,
    screenXL: 1280,
    screenXLMin: 1280,
    screenXLMax: 1439,
    screenXXL: 1440,
    screenXXLMin: 1440,
    fontSize: 16,
  },
  components: {
    Layout: {
      bodyBg: 'transparent',
    },
    Typography: {
      fontWeightStrong: 500,
    },
  },
};
